module.exports = __webpack_public_path__ + "media/components/maps/apps/icons/highlyNegative-df0840e0f5099e323952aabb388e9b55.png";